import IntlProvider from '@setup/intl/IntlProvider/IntlProvider';
import { store } from '@app/store';
import { Provider } from 'react-redux';
import { theme } from '@setup/theme/theme';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AppLoader } from '@components';
import Toast from '@components/Toast/Toast';
import 'react-toastify/dist/ReactToastify.css';
import { IntercomProvider } from 'react-use-intercom';

interface Props {
  children?: React.ReactNode;
}

export const Providers: React.FC<Props> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <IntlProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <CssBaseline />
          <IntercomProvider
            appId={process.env.REACT_APP_INTERCOM_APP_ID ?? ''}
            apiBase={process.env.REACT_APP_INTERCOM_API_BASE}
          >
            <Provider store={store}>
              {children}
              <AppLoader />
              <Toast />
            </Provider>
          </IntercomProvider>
        </LocalizationProvider>
      </IntlProvider>
    </ThemeProvider>
  );
};
